import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useScrollSpy} from 'components/ScrollSpy'
import {getScrollToTarget} from 'modules/accommodation/selectors'
import {setScrollToApTarget} from 'modules/accommodation/slice'

export const useDeferredScrollToApTarget = () => {
  const dispatch = useDispatch()
  const {onNavigate} = useScrollSpy()
  const scrollTarget = useSelector(getScrollToTarget)
  useEffect(() => {
    if (!scrollTarget) return

    // Waiting a bit in case we have to close additional overlay before scrolling to target
    setTimeout(() => onNavigate(scrollTarget), 100)
    dispatch(setScrollToApTarget({target: null}))
  }, [dispatch, onNavigate, scrollTarget])
}
